import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { useUseItem } from '@/api/queries';
import { useAuthStore } from '@/store/authStore';
import { useModalPayload, useUIStore } from '@/store/uiStore';
import { hapticNotify } from '@/lib/telegram';
import type { InventoryItem, UsableItemId } from '@/types';

interface Payload {
  itemId: UsableItemId;
  item: InventoryItem;
}

export function ItemConfirmModal() {
  const open = useUIStore((s) => s.isModalOpen('item-confirm'));
  const closeModal = useUIStore((s) => s.closeModal);
  const payload = useModalPayload<Payload>('item-confirm');
  const userId = useAuthStore((s) => s.userId) ?? 0;
  const pushNotification = useUIStore((s) => s.pushNotification);
  const useItem = useUseItem(userId);

  if (!open || !payload) return null;
  const { item, itemId } = payload;

  return (
    <Modal open={open} onClose={() => closeModal('item-confirm')} title="Использовать?">
      <div className="p-4 space-y-3">
        <div className="flex items-center gap-3">
          <img
            src={`/data/items/${item.icon}`}
            alt={item.name}
            className="w-14 h-14 object-contain"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
          <div className="flex-1">
            <div className="font-medium text-white">{item.name}</div>
            <div className="text-xs text-white/60 mt-0.5">{item.description}</div>
          </div>
        </div>
        <div className="flex gap-2">
          <Button
            variant="secondary"
            fullWidth
            onClick={() => closeModal('item-confirm')}
          >
            Отмена
          </Button>
          <Button
            fullWidth
            onClick={async () => {
              try {
                const res = await useItem.mutateAsync({ item_id: itemId });
                if (res.success) {
                  hapticNotify('success');
                  pushNotification({
                    type: 'success',
                    message: res.message ?? `Использовано: ${item.name}`,
                  });
                } else {
                  pushNotification({ type: 'error', message: res.error ?? 'Ошибка' });
                }
                closeModal('item-confirm');
              } catch (err) {
                hapticNotify('error');
                const message =
                  err instanceof Error ? err.message : 'Не удалось использовать';
                pushNotification({ type: 'error', message });
              }
            }}
            disabled={useItem.isPending}
          >
            {useItem.isPending ? '…' : 'Использовать'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
